import React from "react";
import ProfileButton from "./Profile/ProfileButton";
import StatisticsButton from "./Statistics/StatisticsButton";
import { Image, Pressable, View, useWindowDimensions } from "react-native";
import HomeButton from "./Home/HomeButton";
import { useNavigation, useIsFocused } from "@react-navigation/native";
import { PreferencesContext } from "../Contexts/PreferencesContext";
import { IconButton, Text } from "react-native-paper";
import { useTheme } from "../Contexts/ThemeContext";
import { useLogo } from "../Styling/logos";

const Header = () => {
  const navigation: any = useNavigation();
  const { theme } = useTheme();

  const { currentPage, updateCurrentPage, featurePreviewSetting } =
    React.useContext(PreferencesContext);

  const size = useWindowDimensions();
  const minSize = Math.min(size.width, size.height);
  const featurePreviewText = minSize >= 500 ? "Feature Preview" : "FP";

  const logoUrl = useLogo();

  const statisticsButton = (currentPage: string) => {
    if (currentPage !== "StatisticsPage") {
      return <StatisticsButton />;
    } else {
      return <HomeButton />;
    }
  };

  const profileButton = (currentPage: string) => {
    if (currentPage !== "ProfilePage") {
      return <ProfileButton />;
    } else {
      return <HomeButton />;
    }
  };

  const isFocused = useIsFocused();
  if (!isFocused) return <Text>Error Loading Page</Text>;

  return (
    <View
      style={{
        flexDirection: "row",
      }}
    >
      <IconButton
        icon="menu"
        testID="OpenDrawerNavigation"
        size={20}
        onPress={() => navigation.toggleDrawer()}
      />
      {/*
       * If we are on the Home page, Logo will not navigate to the Home page
       * If we are on any other page, Logo will navigate to the Home page
       */}
      <Pressable
        disabled={currentPage === "HomePage"}
        onPress={() => {
          updateCurrentPage("HomePage");
          navigation.navigate("HomePage");
        }}
      >
        <Image
          style={{
            resizeMode: "cover",
            height: 45,
            width: 100,
          }}
          defaultSource={logoUrl} // bruh adding this fixed the flickering issue bruh
          source={logoUrl}
        />
      </Pressable>
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        {featurePreviewSetting && (
          <View
            style={{
              alignSelf: "center",
              // Prevent macOS WebKit from rounding the text's right edge inward.
              marginRight: 0.5,
            }}
          >
            <Text
              testID="FeaturePreviewText"
              style={{
                color: theme.colors.primary,
                fontWeight: "bold",
              }}
            >
              {featurePreviewText}
            </Text>
          </View>
        )}
        {statisticsButton(currentPage)}
        {profileButton(currentPage)}
      </View>
    </View>
  );
};

export default Header;
